import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Checkbox, Typography } from 'seagull';
import { StepPage } from '~/client-flow/components/StepPage';
import AccountantAccessLearnMoreButton from '~/components/AccountantAccessLearnMoreButton';
import { useLocaleKeys } from '~/i18n';
import { RequestAccountantAccess } from '~/models/request-accountant-access';
import { COBStep, getStepName, stepsTextsPath } from '../ClientOnboarding.utils';
import { useCobConfig } from '../CobConfigContext';
import { useCobStorage } from '../CobStorageContext';
import styles from './AccountantAccessStep.module.scss';
export default function AccountantAccessStep(props) {
    const { onDone, onBack } = props;
    const { relationship } = useCobConfig();
    const { getFromStorage, setToStorage } = useCobStorage(relationship);
    const [checked, setChecked] = useState(()=>getFromStorage('request_accountant_access') || false);
    const isNextDisabled = relationship.requestAccountantAccess === RequestAccountantAccess.Mandatory && !checked;
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const { t: footerTexts } = useLocaleKeys('clientFlow.footer');
    return /*#__PURE__*/ _jsx(StepPage, {
        header: getStepName(COBStep.accountantAccess, relationship, stepsTexts),
        testId: "accountant-access-step",
        primaryBtn: /*#__PURE__*/ _jsx(Button, {
            disabled: isNextDisabled,
            tooltip: {
                title: isNextDisabled ? 'To approve this proposal, Accountant Access permissions must be granted' : ''
            },
            onClick: onDone,
            children: footerTexts.next()
        }),
        onBackBtnClick: onBack,
        children: /*#__PURE__*/ _jsxs("div", {
            "data-testid": "accountant-access-page",
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    children: [
                        "Accountant Access will allow the ",
                        relationship.vendor.name,
                        " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods."
                    ]
                }),
                /*#__PURE__*/ _jsx(Checkbox, {
                    testId: "accountant-access-checkbox",
                    checked: checked,
                    onChange: (e)=>{
                        const newChecked = e.target.checked;
                        setChecked(newChecked);
                        setToStorage('request_accountant_access', newChecked);
                    },
                    children: /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            "I grant Accountant Access to ",
                            relationship.vendor.name
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(AccountantAccessLearnMoreButton, {
                    isVendor: false
                })
            ]
        })
    });
}
